export const getProfit = (item,useLeverage) => {
  if (!Number(item.lastPrice)) {
    return 0;
  }
  if (Number(item.tradeQty) == 0) {
    return 0;
  }
  let a =
    (Number(item.lastPrice) - Number(item.avgPrice)) * Number(item.tradeQty)
   * (item.leverage_ratio && useLeverage ? Number(item.leverage_ratio) : 1);
  let b = Number(a.toFixed(8)).toLocaleString();
  return b.toString().replace(/\$|,/g, "");
};
export const getProfitPercent = (itemData, useLeverage) => {


  //   let a = this.getProfit(itemData);
  const lastPrice = Number(itemData.lastPrice || 0);
  const avgPrice = Number(itemData.avgPrice || 0);
  const tradeQty = Number(itemData.tradeQty || 0);


  const profit = (lastPrice - avgPrice) * tradeQty;
  const totalInvestment = tradeQty * avgPrice;
  const profitPercent =
    (
      (profit / (totalInvestment || 1)) *
      100 
      * (itemData.leverage_ratio && useLeverage ? Number(itemData.leverage_ratio) : 1)
    ).toFixed(2) + "%";
  return profit === 0 ? "0%" : profitPercent;
};

export const ufGetProfit = (item,useLeverage) => {

  if (!Number(item.lastPrice)) {
    return 0;
  }
  if (Number(item.shortTradeQty) == 0) {
    return 0;
  }
  let a =
    (Number(item.lastPrice || 0) - Number(item.shortAvgPrice)) *
    Number(item.shortTradeQty)
  * (item.leverage_ratio && useLeverage ? Number(item.leverage_ratio) : 1);
  let b = Number(a.toFixed(8)).toLocaleString();
  return b.toString().replace(/\$|,/g, "");
};
export const ufGetProfitPercent = (itemData, useLeverage) => {
  const { lastPrice, shortAvgPrice, shortTradeQty } = itemData;


  const profit =
    (Number(lastPrice || 0) - Number(shortAvgPrice || 0)) *
    Number(shortTradeQty || 0);
  const totalInvestment =
    Number(shortTradeQty || 0) * Number(shortAvgPrice || 0);

  if (profit === 0) {
    return "0";
  }

  const profitPercent = (
    (profit / (totalInvestment || 1)) *
    100 
    * (itemData.leverage_ratio && useLeverage ? Number(itemData.leverage_ratio) : 1)
  ).toFixed(2);
  return profitPercent;
};
